
export const suggestedCaptions = [
  "Dream. Plan. Do. 💫",

  "Tag your Love💖",
  // "Dream big, shine bigger ✨",
  "No limits, only vibes 💫",
  "Slay all day 💎",
  // "Good vibes only 🌈",
  "Boss mode: ON 🔥",
  // "Keep shining ✨",
  "Chasing sunsets 🌅",
  "Self-love first 💖",
  "Mood: unstoppable",
  "Glow up season 🌟",
  "Weekend mood 😎",
  "Confidence is key 🔑",
  // "Stay golden 🌟",
  "Hustle in silence 💼",
  "Positive energy only ✨",
  "Be your own hero 🦸",
  "Less perfection, more authenticity 🌿",
  "Do what you love ❤️",
  "Fearless & free 🕊️",
  "Vibes speak louder than words 🎶",
  // "Collect moments, not things 🌸",
//   "Chill mode activated 😌",
//   "Rise & grind 💪",
//   // "Smile more, worry less 😊",
//   "Bold moves only ⚡",
//   "Happiness is homemade 🏡",
//   "Keep it classy 💎",
//   "Life’s too short ✨",
//   "Be the energy you want 💫",
//   "Sassy, classy, and a bit smart-assy 😉",
//   "Adventure awaits 🌍",
//   "Good things take time ⏳",
//   "Radiate positivity 🌞",
//   "Queen energy 👑",
// //   "Just vibe with it ✨",
//   "Stay wild, moon child 🌙",
//   "Hustle hard, shine harder 💥",
//   // "Create your own sunshine ☀️",
//   "Stay humble, hustle hard 💼",
//   "Love yourself first 💖",
//   "Be fearless, be you 🌟",
  
//   "Collect memories, not regrets 🌸",
//   "Chase the stars ✨",
//   "Smile, it’s free therapy 😄",
//   "Be bold, be brave ⚡",
//   "Own your story 📖",
//   "Glow like you mean it 🌟",
//   "Radiate confidence 💎",
//   "Stay golden, never settle 🌟",
//   "Make it happen 💪",

  //Loved Caption Starts
  // "❤️❤️",
  
//     "You are my today and all of my tomorrows ❤️",
// "I look at you and see my whole world 💫",
// "Love is a feeling, you are my proof 💖",
// "You + Me = Forever kind of vibe 🤍",
// "Falling for you again and again 💞",
// "The best moments are always with you ✨",
// "I still get butterflies when I see you 🦋",
// "In your arms is where I belong 🫶",
// "My heart knew before I did 💗",
// "You're my favorite notification 💌",

// attitude Captions Starts

//   "I don’t compete — I elevate 💯",
// "I’m not for everyone… and that’s my superpower 😌",
// "Classy never trashy, and always a little sassy 💋",
// "I walk in rooms like I own them 💅",
// "My circle is small but my mindset is huge 💥",
// "If you think I care… you’re adorable 🙂",
// "Don’t study me — you won’t graduate 🖤",
// "Leveling up, watch me not tell you 🔥",
// "I’m the whole vibe, not just the moment ⚡",
// "Haters hate, queens elevate 👑",


];


// export const generalCaptions = [
//   "Dream big, shine bigger ✨",
//   "Good vibes only 🌈",
//   "Keep shining ✨",
//   "Stay golden 🌟",
//   "Create your own sunshine ☀️",
//   "Smile more, worry less 😊",
//   "Collect moments, not things 🌸"
// ];

// export const natureCaptions = [
//   "Sunlight feels softer here 🌅",
//   "Nature doing its quiet magic 🌿",
//   "Peace you can actually feel 🤍",
//   "Where everything feels lighter ✨",
//   "Just sky, earth, and calm 🌸",
//   "The kind of silence I like 🕊️",
//   "Let the breeze carry it away 🌿",
//   "Soft skies, softer thoughts ✨",
//   "Nothing but nature and me 🤍",
//   "A moment worth staying in 🌅",

//   "This view says everything 🌿",
//   "Slow days, soft light ✨",
//   "Wrapped in nature’s calm 🤍",
//   "No rush, just this 🌸",
//   "The sky understood the mood 🌅",
//   "Peace found its way here 🌿",
//   "Quiet, but not empty ✨",
//   "Let nature take over 🤍",
//   "Just watching the world slow down 🌸",
//   "Where thoughts feel lighter 🌿",

//   "Nature feels like home 🤍",
//   "Soft winds, clear mind 🌿",
//   "A little closer to peace ✨",
//   "No noise, just calm 🌸",
//   "The kind of stillness I needed 🤍",
//   "Lost somewhere peaceful 🌿",
//   "Just breathe and stay ✨",
//   "Everything feels okay here 🤍",
//   "The calm I was looking for 🌅",
//   "Simple views, deep feelings 🌸",

//   "This is enough 🌿",
//   "Sky above, peace within ✨",
//   "Let the quiet settle in 🤍",
//   "A soft escape 🌸",
//   "Nothing but good energy 🌿",
//   "Just nature doing its thing ✨",
//   "Feels like a reset 🤍",
//   "Calm looks good on me 🌸",
//   "Where worries fade away 🌿",
//   "A moment I don’t want to leave ✨"
// ];


export const natureCaptions = [
  "I didn’t know I needed this kind of silence 🌿",
  "This place slowed something inside me 🌅",
  // "For a moment… everything felt okay 🤍",
  "I wish I could stay in this feeling a little longer ✨",
  "Nothing changed, but I feel different 🌸",

  "The world felt softer here… and so did I 🌿",
  "I stopped thinking… and just existed 🌅",
  "This is what peace actually feels like 🤍",
  "Some places don’t ask anything from you ✨",
  "I came here tired… leaving lighter 🌸",

  "No noise, no pressure… just me 🌿",
  "This moment didn’t need anything extra 🌅",
  "I forgot about everything for a second 🤍",
  "Not perfect… but exactly what I needed ✨",
  "This felt like a reset I didn’t plan 🌸",

  "Somewhere between quiet and healing 🌿",
  "This view held me for a moment 🌅",
  "I didn’t take a photo… I felt it 🤍",
  "Time slowed down without asking ✨",
  "Nothing urgent here… and I like that 🌸",

  "I didn’t come here for peace… but found it 🌿",
  "This moment stayed with me 🌅",
  "No captions needed… but here we are 🤍",
  "This is the version of me I like ✨",
  "Soft place, softer thoughts 🌸"
];

// export const generalCaptions = [
//   // "Soft light, calm mind 🌿",
//   "Moments that feel like this ✨",
//   "A little pause in a busy world 🤍",
//   "Let the moment speak 🌅",
//   "Simple things, deep feelings 🌸",
//   // "Where time slows down 🕊️",
//   "Just this moment, nothing else 🌿",


//     // 🔥 add more like this
//   "Quiet moments, loud memories 🤍",
//   "Lost in the beauty of now ✨",
//   "This feels like peace 🌿",
//   "Nothing fancy, just real 🌸",
//   "Time paused for a second 🕊️",
//   "In the mood for calm ✨",
//   "Breathing in this moment 🌿",
//   "Stillness speaks louder 🤍",
//   "A vibe you can’t explain ✨",
//   "Some moments don’t need words 🌸",
//   "This is what calm looks like 🌿",
//   // "Just being here feels enough 🤍",
//   // "Let it be simple ✨",

//   "This felt different… in a good way 🤍",
//   "I didn’t expect this moment to stay with me ✨",
//   "Some peace you don’t notice… until you feel it 🌿",
//   "I wish I could pause time right here 🕊️",
//   "Not everything needs to be loud to be beautiful 🌸",
//   "This is the kind of moment I don’t want to lose ✨",
//   "You ever feel like this… and don’t know why? 🤍",
//   "No filters. Just how it felt 🌿",
//   "I didn’t plan this… but I needed it ✨",
//   "This moment fixed something in me 🤍",
//   "Quiet outside… peaceful inside 🌿",
//   "Nothing special… but somehow everything ✨",
//   "If calm had a face, it would look like this 🌸",
//   "Some moments don’t ask for attention… but deserve it 🤍",
//   "I didn’t take this photo… I felt it 🌿",
//   "This is what slowing down looks like ✨",
//   "You can’t recreate moments like this 🤍",
//   "It’s not perfect… but it’s real 🌿",
//   "Felt small in the best way possible ✨",
//   "This is your sign to pause for a second 🕊️"
// ];


export const generalCaptions = [
  // 🌿 SOFT (keep your original tone)
  "Some moments don’t last… but they stay 🤍",
  // "This felt small… but meant everything 🌸",
  "For a second… nothing else mattered 🤍",
  "This is what peace looks like for me 🤍",
  "Quiet outside… peaceful inside 🌿",
  "Not everything needs to be loud to be beautiful 🌸",

  // 🔥 IDENTITY (new – strong)
  "I stopped explaining myself.",
  "I outgrew what I used to beg for.",
  "I’m not the same anymore.",
  "Peace feels better than proving anything.",
  "I chose peace over people.",
  "Not everyone deserves access anymore.",

  // 💭 RELATABLE (mid strength)
  "You ever feel like this… and don’t know why? 🤍",
  "Some people will understand this… some won’t.",
  "This phase is different.",
  "If you know, you know.",
  "This felt too real to ignore.",
  "I didn’t expect this to stay with me.",

  // ⚡ MEMORABLE (short + punchy)
 "Nothing changed… but something in me did.",
  "I didn’t say anything… but I understood everything.",
  "It was quiet… but not empty.",
  "This didn’t fix anything… but it helped.",
  "I felt it more than I can explain.",
  "It looked normal… but it wasn’t.",
  "I didn’t realize it then… but this mattered.",
  "This stayed longer than I expected.",
  "I can’t explain it… but it felt right.",
  "It didn’t need words to mean something.",
  "I left with less… but felt more.",
  "This moment knew something I didn’t.",
  "It passed quickly… but stayed deeply.",
  "I didn’t hold onto it… but it stayed.",
  "It wasn’t loud… but it was real.",


  // 🌸 HYBRID (your style but stronger)
  "I didn’t take this… I lived it 🌿",
  "This moment fixed something in me 🤍",
  "I wish I could pause time right here 🕊️",
  "This is the kind of moment I don’t want to lose ✨",
  "It’s not perfect… but it’s real 🌿",
  "You can’t recreate moments like this 🤍",
  "This is your sign to pause for a second 🕊️",
  "No filters. Just how it felt 🌿",
  "Sometimes calm hits you unexpectedly 🌸",
  "This felt different… in a good way 🤍"
];



export const attitudeCaptions = [
  "I don’t compete — I elevate 💯",
"I’m not for everyone… and that’s my superpower 😌",
"Classy never trashy, and always a little sassy 💋",
"I walk in rooms like I own them 💅",
"My circle is small but my mindset is huge 💥",
"If you think I care… you’re adorable 🙂",
"Don’t study me — you won’t graduate 🖤",
"Leveling up, watch me not tell you 🔥",
"I’m the whole vibe, not just the moment ⚡",
"Haters hate, queens elevate 👑",
]

export const coffeeCaptions = [
  "Coffee first, everything else later ☕",
  "Life begins after coffee ☕",
  "Sip. Relax. Repeat ☕",
  "Morning fuel ☕",
  "Brewed happiness ☕",
  "Coffee and calm vibes ☕"
];

export const captionsIntentMap = {
  // ❤️ Love / Romance
  "Love and Romance": "love",
  "Couples": "love",
  "Date Night": "love",
  "Romantic Moments": "love",
  "Hugs and Kisses": "love",
  "Sibling Love": "love",
  "Family Time": "love",

  // 😎 Attitude / Fashion / Bold
  "Fashion": "attitude",
  "Fashion Trends": "attitude",
  "Makeup and Beauty": "attitude",
  "Luxury and Lifestyle": "attitude",
  "Boss Mode": "attitude",
  "BMW Night": "attitude",
  "Nightlife": "attitude",

  // 🌅 Motivation / Aesthetic / Calm
  "Sunsets and Sunrises": "general",
  "Golden Hour": "general",
  "Morning Light": "general",
  "Motivation and Productivity": "general",
  "Quotes and Inspiration": "general",
  "Fitness Motivation": "general",
  "Workspace Inspiration": "general",
  "Minimalist Aesthetics": "general",
  "Nature Trails": "general",
    "Bedrooms": "interior",

};

export const interiorCaptions = [
  "Home is where comfort lives 🏡",
  "Creating a space that feels like me ✨",
  "Peace begins at home 🤍",
  "Less noise, more calm 🌿",
  "A place to breathe and reset 🛋️",
  "Simple spaces, beautiful moments ✨",
  "Design your calm 🕊️",
  "Where every corner tells a story 🏡",
  "Comfort is the new luxury 🤍",
  "Living in my kind of peace 🌿"
];

export const tagIntentMap = {
  love: [
    "love",
    "romantic",
    "couple",
    "kiss",
    "hug",
    "heart",
    "wedding", 
    "rose",
  "flower",
  "valentine",
  "proposal",
  "anniversary"
  ],

  attitude: [
    "fashion",
    "luxury",
    "bmw",
    "car",
    "night",
    "model",
    "style"
  ],

 
   coffee: [
  "coffee",
  "espresso",
  "cafe",
  "latte",
  "cappuccino",
  "americano",
  "coffee cup",
  "coffee mug",
  "coffee beans",
  "barista",
  "coffee shop",
  "morning coffee",
  "brew",
  "filter coffee"
],
   nature: [
  "sunrise",
  "sunset",
  "ocean-sunset",
  "mountain",
  "forest",
  "river",
  "lake",
  "waterfall",
  "sky",
  "cloud",
  "beach",
  "sea",
  "trees",
  "landscape"
]
};

 // general: [
  //   "sunset",
  //   "sunrise",
  //   "nature",
  //   "mountain",
  //   "beach",
  //   "sky",
  //   "morning"
  // ],
export const TravelCaptions = [

"Some places just stay with you ✈️",

"Out of office, into the world 🌍",

"Collecting moments from places I'll never forget ✨",

"Somewhere far from everything 🌍",

"I think I belong somewhere on the road ✈️",

"Just me and a place I've never been before 🤍",



"The view was worth the journey 🌄",

"Gone somewhere I feel more alive 🌍",

"Not all who wander are lost ✈️",

"Take me where the Wi-Fi is weak and the memories are strong 🌄",

];

export const BirthdayCaptions = [

  "Feeling extra loved today. 🤍",


"Just here for the cake and the memories 🎉",

  "Cheers to another chapter of my life. 🥂",

"Growing older, but never growing out of birthdays 🎈",

"Today is all about good vibes and cake 🎂",



// "Feeling extra loved today 🤍",

"Making memories and eating cake 🎂✨",

// "Officially a year older today 🎈",
"One more year, a little wiser, and still celebration. 🎈✨",

"Birthday mood: on 🎂✨",

"One more year, one more reason to celebrate 🎉",



];

export const FriendsCaptions = [

"Life is better with friends 🫶",

"Just good friends and good memories ✨",

"Some friendships just feel like home 🏠",

"Making memories with my favourite people 📸",

"No matter where life takes us, these memories stay 🫶",

"Good times + crazy friends = best memories 😂",

"Friends who became family 🤍",

"Some people just make everything better ✨",

"The kind of people you never want to outgrow 🤍",

"Chaos, laughs, and memories 📸",

"Same people, different memories 🫶",

];

export const AttitudeCaptions = [

"I know who I am, and that's enough 😎",

"Not everyone has to like me, and that's okay ✨",

"Less talk, more action 💯",

"I'm not here to fit in 😎",

"My vibe speaks before I do ✨",

"Stay real, stay different 🔥",

"I don't chase, I attract 😎",

"Silent moves, loud results 🔥",

"I'm my own competition 😎",

"Born to stand out ✨",

"No attitude, just standards 😌",

];

// export const LovedCaptions = [

// "My life starts with you... 💫",

// "Your hand is my favourite place 🤍",

// "You are my today and all my tomorrows ❤️",

// "You just feel like home ❤️",

// "You + me, that's all I need 🤍",

// "Falling for you, again and again 💞",

// "The best moments are the ones with you ✨",

// "I still get butterflies when I see you 🦋",

// "My favourite place is right next to you 🫶",

// "Somehow, you became my favourite person 💗",

// "Your messages still make me smile 💌",

// ];


export const LovedCaptions = [
  "You make ordinary moments feel extraordinary 🫶",
  "I'd choose you in every version of my life ❤️❤️",
  "My life starts with you... 💫",
  "Your hand is my favourite place 🤍",
  "Your messages still make me smile 💌",
  "Miles apart, but you're never far from my heart. 🌙",
  "My favourite place is right next to you 🫶",
  "Falling for you, again and again 💞",
  "Out of all the people in this world, somehow I found you. And I'm so glad. ❤️",
  "I still look at you and wonder how much I lucky. ✨",
  "No perfect day needed — just you beside me. 🤍",
  "You turned ordinary moments into memories I never want to forget. 💞",
  "My favourite part of every day is knowing I get to share it with you. 🫶",
  "Somewhere between the little moments, you became my favourite part of life. 💗",
  "I could spend a thousand ordinary days with you and still want one more. ✨",
  "It's not just that I love you. Life really feels better with you. ❤️",
  "In a world full of changes, you're my constant. 💗",
  "Are you always this cute, or is it just around me? 😉",
  "You're still my favourite notification. 💌",
  "Every your little thing reminds me of you. ❤️",
  "If I could relive one moment, I'd choose you again. ✨",
  "You make even the quietest moments feel special. 🤍",
  "My heart found you, my favorite person. 💞",
  "With you, even an ordinary day feels like a memory. 🫶",
  "Somehow, you make my world feel special. 💗",
  "A thousand little reasons, all leading back to you. ❤️",
  "I never get tired of choosing you. 💍",
  "You feel like my favourite kind of forever. 🤍",
  "One look at you, and the day gets better. 😊",
  "Love is in the little things we do together. 💕",
];

export const NatureCaptions = [
  "Somewhere between the trees, I found myself 🌿",
  
  "A little more sunshine, a little less stress ☀️",
  "Collecting moments, not things 🍃",
  "The sky has its own way of healing 💙",
  "Lost in the right direction 🌲",
  "Where the earth feels like home 🌎",
  "Chasing sunsets and quiet moments 🌅",
  "Nature never goes out of style 🌿",
  "Peace looks a lot like this 🤍",
  "Taking the scenic route, always 🏞️",
  "The best views come with a deep breath 🌄",
  "Green spaces, clear thoughts 🌱",
  "Just me and the endless sky ☁️",
  "A moment of calm in a noisy world 🍃",
  "Meet me where the wild things grow 🌾",
  "The mountains are calling, and I need to go 🏔️",
  "Sunshine feels different when you slow down 🌞",
  "Every sunset is a reason to pause 🌇",
  "Wild air, quiet mind, happy heart 💚",
  "Let the wind carry away what you don't need 🌬️",
  "The world is beautiful when you take your time 🌍",
  "Blue skies and nowhere to rush 💙",
  "A little closer to nature, a little closer to peace 🌿",
  "Views that make you forget to check your phone 📵",
  "Earth tones and peaceful souls 🤎",
  "Breathing in the beauty, one moment at a time 🌳",
  "The kind of place that makes you stay a little longer 🏞️",
  "Cloud watching is my kind of therapy ☁️",
  "If you need me, I'll be outside 🌻",
  "Finding magic in the ordinary 🌼",
  "Fresh air, fresh perspective 🌱",
  "Let the flowers remind you to keep growing 🌸",
  "Nothing to prove, nowhere to be 🌾",
  "A quiet morning surrounded by green 🌿",
  "Where the river flows, let your worries go 💧",
  "Sunlight, fresh air, and a grateful heart ☀️",
  "The wild has a way of bringing you back to yourself 🌲",
  "Some views deserve more than a photograph 📸",
  "Just a small human in a beautiful world 🌎"
]; 



export const intelligentCaptions = [

  // LOVE
  {
    text: "I'd choose you in every version of my life. ❤️",
    keywords: ["love", "couple", "romantic", "relationship", "together"],
    intent: "love"
  },
  {
    text: "Your hand is my favourite place. 🤍",
    keywords: ["couple", "holding hands", "hands", "romantic"],
    intent: "love"
  },
  {
    text: "You make ordinary moments feel extraordinary. 🫶",
    keywords: ["couple", "love", "romantic", "together"],
    intent: "love"
  },
  {
    text: "Miles apart, but you're never far from my heart. 🌙",
    keywords: ["long distance", "distance", "couple", "love"],
    intent: "love"
  },
  {
    text: "Are you always this cute, or is it just around me? 😉",
    keywords: ["couple", "romantic", "flirting", "love"],
    intent: "love"
  },
  {
    text: "Another year of us, and I'd still choose you. ❤️",
    keywords: ["anniversary", "couple", "wedding", "love"],
    intent: "love"
  },
  {
    text: "A little sweat, a lot of love. ❤️",
    keywords: ["gym", "workout", "fitness", "couple", "training"],
    intent: "love"
  },

  // NATURE
  {
    text: "A little beauty makes the whole world brighter. 🌹",
    keywords: ["roses", "red roses", "flowers", "bouquet", "red flowers"],
    intent: "nature"
  },
  {
    text: "Some flowers make ordinary moments feel special. 🌸",
    keywords: ["flowers", "bouquet", "flower background", "blossom"],
    intent: "nature"
  },
  {
    text: "A beautiful reminder to slow down and enjoy the moment. 🌿",
    keywords: ["nature", "green", "trees", "forest", "landscape"],
    intent: "nature"
  },
  {
    text: "The sky has a way of making every moment feel different. ☁️",
    keywords: ["sky", "clouds", "blue sky"],
    intent: "nature"
  },
  {
    text: "Some sunsets are worth remembering forever. 🌅",
    keywords: ["sunset", "sunrise", "golden hour", "evening sky"],
    intent: "nature"
  },
  {
    text: "The mountains are calling, and I need to go. 🏔️",
    keywords: ["mountains", "mountain landscape", "hills", "peaks"],
    intent: "nature"
  },
  {
    text: "Where the river flows, let your worries go. 💧",
    keywords: ["river", "waterfall", "lake", "water"],
    intent: "nature"
  },
  {
    text: "Blue skies and nowhere to rush. 💙",
    keywords: ["blue sky", "clouds", "sky"],
    intent: "nature"
  },

  // BIRTHDAY
  {
    text: "Feeling extra loved today. 🤍",
    keywords: ["birthday", "birthday party", "celebration", "birthday cake"],
    intent: "birthday"
  },
  {
    text: "Just here for the cake and the memories. 🎉",
    keywords: ["cake", "birthday cake", "birthday party", "celebration"],
    intent: "birthday"
  },
  {
    text: "Cheers to another chapter of my life. 🥂",
    keywords: ["birthday", "birthday celebration", "party", "balloons"],
    intent: "birthday"
  },
  {
    text: "Today deserves a little extra sparkle. ✨",
    keywords: ["birthday decorations", "party", "celebration", "birthday"],
    intent: "birthday"
  },

  // FRIENDS
  {
    text: "Life is better with friends. 🫶",
    keywords: ["friends", "friendship", "group of friends", "people together"],
    intent: "friends"
  },
  {
    text: "Just good friends and good memories. ✨",
    keywords: ["friends", "friendship", "group photo", "memories"],
    intent: "friends"
  },
  {
    text: "Some friendships just feel like home. 🏠",
    keywords: ["best friends", "friendship", "close friends"],
    intent: "friends"
  },
  {
    text: "Chaos, laughs, and memories. 📸",
    keywords: ["friends", "group of friends", "fun", "party"],
    intent: "friends"
  },

  // ATTITUDE
  {
    text: "I know who I am, and that's enough. 😎",
    keywords: ["portrait", "fashion", "model", "style", "selfie"],
    intent: "attitude"
  },
  {
    text: "Less talk, more action. 💯",
    keywords: ["gym", "fitness", "workout", "motivation", "training"],
    intent: "attitude"
  },
  {
    text: "My vibe speaks before I do. ✨",
    keywords: ["fashion", "style", "portrait", "outfit"],
    intent: "attitude"
  },
  {
    text: "Silent moves, loud results. 🔥",
    keywords: ["car", "luxury car", "fashion", "success"],
    intent: "attitude"
  },
  {
    text: "Focused on progress, not approval. 🎯",
    keywords: ["fitness", "gym", "workout", "motivation"],
    intent: "attitude"
  },

  // TRAVEL
  {
    text: "Some places just stay with you. ✈️",
    keywords: ["travel", "destination", "landscape", "vacation"],
    intent: "travel"
  },
  {
    text: "Out of office, into the world. 🌍",
    keywords: ["travel", "adventure", "holiday", "vacation"],
    intent: "travel"
  },
  {
    text: "The view was worth the journey. 🌄",
    keywords: ["mountains", "travel", "road trip", "landscape"],
    intent: "travel"
  },
  {
    text: "New streets, new stories, same curious heart. 🌍",
    keywords: ["city", "street", "travel", "urban", "architecture"],
    intent: "travel"
  },

  // COFFEE
  {
    text: "A little coffee and a lot of peace. ☕",
    keywords: ["coffee", "coffee cup", "coffee mug", "cafe"],
    intent: "coffee"
  },
  {
    text: "But first, coffee. ☕",
    keywords: ["coffee", "espresso", "latte", "cappuccino"],
    intent: "coffee"
  },
  {
    text: "Good days start with good coffee. 🤎",
    keywords: ["morning coffee", "coffee beans", "coffee cup", "cafe"],
    intent: "coffee"
  },

  // INTERIOR
  {
    text: "Home is where every little detail feels right. 🤍",
    keywords: ["interior", "home", "living room", "home decor"],
    intent: "interior"
  },
  {
    text: "Creating a space that feels like me. ✨",
    keywords: ["interior design", "bedroom", "room decor", "home decor"],
    intent: "interior"
  },
  {
    text: "Simple spaces, beautiful feelings. 🏡",
    keywords: ["minimalist interior", "interior design", "architecture", "home"],
    intent: "interior"
  }

];
